<div class="modal-header">
    <button aria-label="Close" class="close" (click)="cancel()" type="button"><span aria-hidden="true">×</span></button>
    <h4 class="modal-title" id="vcdModalLabel">Customer Search</h4>
</div>

<div class="modal-body">
    <customer-search-container (onCustomerSelected)="customerSelected($event)"
        (onCustomerNameClicked)="customerNameClicked($event)" [data]="data.searchView"
        [includeDeceased]="data.includeDeceased">
    </customer-search-container>
</div>

<div class="modal-footer">
    <div class="btn--group">
        <button class="btn--primary" type="button" (click)="cancel()">Close</button>
    </div>
</div>
